import styled from 'styled-components';
import { unitizedPx } from '@badi/badi-components';

export const PremiumWrapper = styled.div`
  position: absolute;
  top: 0;
  left: ${unitizedPx(0.5)};
`;
